import { call, put, takeLatest, select } from "redux-saga/effects";
import _ from "lodash";

import { actions as notificationActions } from "~/notifications";
import { actions as preferenceActions } from "~/admin/setup/preference/data";
import { ANALYZE_CATEGORY_INDEX } from "~/admin/setup/batch-zapper/data/constants";
import { NavigationAPI, UserAPI, ZapperAPI, Request } from "@ai360/core";
import * as loginActions from "~/login/actions";
import { getTheUserGuid } from "~/login/selectors";

import * as actions from "./actions";
import { Messages } from "./i18n-messages";

function filterNavigationLists(theUser, zapper): Promise<NavigationAPI.INavigation[]> {
    /* eslint-disable no-console */
    return UserAPI.getNavigationLists(theUser.userGuid, "Main").then((response) => {
        //remove items which are not pages or parent items from the list
        //Todo: This could be done on the server after the remediation
        const filteredArray = [];
        const arrayToIgnore = [
            "103",
            "104",
            "106",
            "109",
            "110",
            "111",
            "112",
            "113",
            "114",
            "115",
            "116",
            "119",
            "184",
            "185",
            "207",
            "208",
            "218",
            "222",
            "230",
            "231",
            "232",
            "240",
            "244",
            "245",
            "246",
            "248",
            "249",
            "250",
            "270",
        ];
        if (!zapper.some((x) => x.categoryName === ANALYZE_CATEGORY_INDEX)) {
            arrayToIgnore.push("256"); // Analyze
        }
        _.forEachRight(response.gearboxList, function (listItem) {
            if (!_.includes(arrayToIgnore, listItem.softwareFunctionNameCode)) {
                //loop through child lists and only push items which will display
                if (listItem.userChildDashboardGearBox) {
                    if (
                        listItem.softwareFunctionNameCode === "105" &&
                        (listItem.userChildDashboardGearBox.gearboxList?.length ?? 0) > 0
                    ) {
                        listItem.userChildDashboardGearBox.gearboxList.unshift({
                            softwareFunctionGuid: listItem.softwareFunctionGuid,
                            softwareFunctionName: listItem.softwareFunctionName,
                            softwareFunctionNameCode: listItem.softwareFunctionNameCode,
                            userChildDashboardGearBox: null,
                            visibleYn: true,
                        });
                    }

                    const childArray = [];
                    _.forEachRight(
                        listItem.userChildDashboardGearBox.gearboxList,
                        function (childListItem) {
                            if (
                                !_.includes(arrayToIgnore, childListItem.softwareFunctionNameCode)
                            ) {
                                if (!(childListItem.softwareFunctionNameCode in Messages)) {
                                    console.warn(
                                        "skipping unknown `childListItem.softwareFunctionNameCode`",
                                        childListItem.softwareFunctionNameCode
                                    );
                                } else {
                                    childListItem.label =
                                        Messages[childListItem.softwareFunctionNameCode] || "X";
                                    childListItem.key = childListItem.softwareFunctionGuid;
                                    childListItem.action = () => null;
                                    childArray.push(childListItem);
                                }
                            }
                        }
                    );
                    listItem.gearboxList = childArray;
                }
                listItem.displayText = Messages[listItem.softwareFunctionNameCode];
                filteredArray.push(listItem);
            }
        });
        return filteredArray;
    });
}

function* getNavigationLists(setUserAction) {
    try {
        const UserGuid = yield select(getTheUserGuid);
        const requestOptions = { UserGuid, Model: {} };
        const zapperResponse = yield call(
            Request.post,
            ZapperAPI.FETCH_ATTRIBUTES_URL,
            requestOptions
        );

        const navList: NavigationAPI.INavigation[] = yield call(
            filterNavigationLists,
            setUserAction.theUser,
            zapperResponse
        );
        yield put(actions.navlistFetchSucceeded(navList));
    } catch (e) {
        yield put(notificationActions.apiCallError(e));
    } finally {
        yield put(notificationActions.fetchUserNotifications());
        yield put(preferenceActions.fetchPreference());
        yield put(preferenceActions.fetchColorOverride());
        yield put(preferenceActions.fetchColorOverrideType());
    }
}

export function* navSaga() {
    yield takeLatest(loginActions.SET_USER_INFO_COMPLETE, getNavigationLists);
}
